import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import categoryProductReducer from "./slices/categoryProduct-slice";
import categorySelectionReducer from "./slices/categorySelection-slice";
import productPageReducer from "./slices/productPage-slice";
import collectionPageReducer from "./slices/collectionPage-slice";
import productReducer from "./slices/product-slice";
import collectionDetailProductReducer from "./slices/collectionProduct-slice";
import currencyReducer from "./slices/currency-slice";
import cartReducer from "./slices/cart-slice";
import compareReducer from "./slices/compare-slice";
import wishlistReducer from "./slices/wishlist-slice";
import mainCollectionProductReducer from "./slices/mainCollectionProduct-slice";
import collectionNameReducer from "./slices/collectionName-slice";
import mainCollectionPageReducer from "./slices/mainCollectionPage-slice";
import globalDataObjReducer from "./slices/globalData-slice";
import accessTokenReducer from "./slices/authSlice";
import subCategoryReducer from "./slices/subCategory-slice";
import collectionCategoryReducer from "./slices/collectionCategory-slice";
import collectionSubCategoryReducer from "./slices/subcategoryCollection-slice";
import lineItemReducer from "./slices/lineitemadded-slice";
import logouttoggleReducer from "./slices/logouttoggle-slice";
import policyReducer from "./slices/policyDetail-slice";
import allCategoryReducer from "./slices/all-category-slice";
import activeProductReducer from "./slices/activeProduct-slice"
const persistConfig = {
  key: "flone",
  version: 1.1,
  storage,
  blacklist: ["product"],
};

export const rootReducer = combineReducers({
  product: productReducer,
  currency: currencyReducer,
  cart: cartReducer,
  compare: compareReducer,
  wishlist: wishlistReducer,
  allCategories: allCategoryReducer,
  categoryProduct: categoryProductReducer,
  categorySelection: categorySelectionReducer,
  productPage: productPageReducer,
  collectionPage: collectionPageReducer,
  collectionProduct: collectionDetailProductReducer,
  mainCollectionProduct: mainCollectionProductReducer,
  collectionName: collectionNameReducer,
  mainCollectionPage: mainCollectionPageReducer,
  globalData: globalDataObjReducer,
  accessToken: accessTokenReducer,
  subCategory: subCategoryReducer,
  collectionCategory: collectionCategoryReducer,
  collectionSubCategory: collectionSubCategoryReducer,
  lineItem: lineItemReducer,
  logouttoggle: logouttoggleReducer,
  policy: policyReducer,
  activeProduct : activeProductReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
